import React, { useEffect, useState } from 'react';
import { v2_dashboard_priorities } from '../../actions/v2/dashboard';

const MyPriorities = () => {
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10, total: 0 });
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const res = await v2_dashboard_priorities(page, limit);
    if (res?.result?.data && res?.result?.pagination) {
      setPagination(res.result.pagination);
      setData(prev => {
        const existingIds = new Set(prev.map(d => d.ID));
        const filteredNew = res.result.data.filter(item => !existingIds.has(item.ID));
        return [...prev, ...filteredNew];
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const handleLoadMore = () => {
    if ((pagination.page * pagination.limit) < pagination.total) {
      setPage(prev => prev + 1);
    }
  };

  return (
    <div className='card'>
      <div className='card-body'>
        <div className='priorities-section'>
          <h4>My Priorities</h4>
          <div className='priorities-contaier'>
            {data?.map((item, index) => (
              <React.Fragment key={item.ID || index}>
                <div className='datePriorities'>{item.END_DATE}</div>
                <div className='priorities-item'>
                  <h5>{item.EVENT_TYPE}</h5>
                  <p>{item.NOTE != 'null' ? item.NOTE : ''}</p>
                  <ul className='priorities-list'>
                    <li className='yard'>{item.HULL_NUMBER} - {item.PROJECT_NAME}</li>
                    <li className='mile'>{item.CATEGORY_NAME}</li>
                  </ul>
                </div>
              </React.Fragment>
            ))}
          </div>

          {(pagination.page * pagination.limit) < pagination.total && (
            <div className="text-center mt-3">
              <button
                className="btn btn-primary"
                onClick={handleLoadMore}
                disabled={loading}
              >
                {loading ? 'Loading...' : 'Load More'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyPriorities;
